import ApiService from '@/core/services/api.service';

export const AccompanyingEquipmentService = {
  getAll(params = {}) {
    return ApiService.query(`v1/warranty/accompanying-equipments`, { params });
  },

  getById(id) {
    return ApiService.get(`v1/warranty/accompanying-equipments/${id}`);
  },

  create(data) {
    return ApiService.post('v1/warranty/accompanying-equipments', data);
  },

  update(id, data) {
    return ApiService.put(`v1/warranty/accompanying-equipments/${id}`, data);
  },

  delete(id) {
    return ApiService.delete(`v1/warranty/accompanying-equipments/${id}`);
  },

  updateActiveStatus(id, isActive) {
    return ApiService.patch(
      `v1/warranty/accompanying-equipments/${id}/active-status`,
      {
        isActive,
      },
    );
  },
};
